import React, { createContext, useState, useContext, useEffect,useRef  } from 'react';
import socket from '../socket';

const GameContext = createContext();

export const useGame = () => useContext(GameContext);

export const GameProvider = ({ children }) => {
  const [game, setGame] = useState(null);
  const [diceRolls, setDiceRolls] = useState({ player1Roll: null, player2Roll: null });
  const [numberMove, setNumberMove] = useState(2);


  
  
  const [firstRolls, setFirstRolls] = useState({ player1Roll: null, player2Roll: null });
  const [tournamentFirstRolls, setTournamentFirstRolls] = useState({ player1Roll: null, player2Roll: null });
  const [isFirstRollEnabled, setIsFirstRollEnabled] = useState({ player1FirstRollEnabled: true, player2FirstRollEnabled: true }); 
  const [currentTurn, setCurrentTurn] = useState(null);
  const [rollEnabled, setRollEnabled] = useState(false);
  const [tournamentRollEnabled, setTournamentRollEnabled] = useState(false);
  const [rollDiceEnabled, setRollDiceEnabled] = useState(false);
  const [confirmMoveEnabled, setConfirmMoveEnabled] = useState(false);
  const [readyStatus, setReadyStatus] = useState({ player1: false, player2: false });
  const [turnCompleted, setTurnCompleted] = useState(false);
  const [showRollDiceButton, setShowRollDiceButton] = useState(true); 
  const [testik, setTestik] = useState(false);
  const [playerColor, setPlayerColor] = useState(null);
  const [rolledDice, setRolledDice] = useState([]);
  const [tournamentRolledDice, setTournamentRolledDice] = useState([]);
  const [isTournament, setIsTournament] = useState(false);
  // const [hasRolledDice, setHasRolledDice] = useState(false); // Индикатор, бросил ли кубики
  // const [showReadyButton, setShowReadyButton] = useState(false);
  // const [showReadyButton, setShowReadyButton] = useState(() => {
  //   // Проверяем, сохранено ли состояние в localStorage
  //   const storedState = localStorage.getItem("showReadyButton");
  //   // Если состояние сохранено, парсим его, иначе возвращаем true
  //   return storedState !== null ? JSON.parse(storedState) : true;
  // });
  // const [showReadyButton, setShowReadyButton]= useState()
  const [usedRolls, setUsedRolls] = useState([]); // Добавляем это состояние
  const [tournamentUsedRolls, setTournamentUsedRolls] = useState([]); // Добавляем это состояние
  const [moveHistory, setMoveHistory] = useState([]); // Сохраняем историю ходов




  const [firstRollComplete, setFirstRollComplete] = useState(false);
  const [tournamentFirstRollComplete, setTournamentFirstRollComplete] = useState(false);
  const [roll1, setRoll1] = useState(null);
  const [roll2, setRoll2] = useState(null);
  const [firstMoveComplete, setFirstMoveComplete] = useState(false);
  const [capturedCheckers, setCapturedCheckers] = useState({ white: 0, black: 0 });
  const [tournamentCapturedCheckers, setTournamentCapturedCheckers] = useState({ white: 0, black: 0 });
  const [capturedCheckerData, setCapturedCheckerData] = useState(null);
  // const [enteredCheckerData, setEnteredCheckerData] = useState(null);
  const [enteredChecker, setEnteredChecker] = useState(null);
  const [enteredCheckerData, setEnteredCheckerData] = useState({ white: 0, black: 0 });
  const [lastEnteredChecker, setLastEnteredChecker] = useState(null); 
  const [bar, setBar] = useState({ white: [], black: [] });
  const [canMove, setCanMove] = useState(false); // Контролирует, можно ли сделать ход
  const [hasJoined, setHasJoined] = useState(false); // Контролирует, можно ли сделать ход
  const [tables, setTables] = useState([]);
  const [tablesLong,setTablesLong] = useState([]);
  const [tablesKhachapuri, setTablesKhachapuri] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [whiteOffBoard, setWhiteOffBoard] = useState([]);
  const [blackOffBoard, setBlackOffBoard] = useState([]);
  const [tournamentWhiteOffBoard, setTournamentWhiteOffBoard] = useState([]);
  const [tournamentBlackOffBoard, setTournamentBlackOffBoard] = useState([]);
  const isInitialMount = useRef(true);
  // const [currentTableId, setCurrentTableId] = useState(null); // Состояние для текущего стола
  const [currentTableId, setCurrentTableId] = useState(localStorage.getItem('currentTableId') || null);
  const [tableStates, setTableStates] = useState(() => {
    const savedTableStates = localStorage.getItem('tableStates');
    return savedTableStates ? JSON.parse(savedTableStates) : {};
  });
  // const [tableStates, setTableStates] = useState({});
  const [openTablesCount, setOpenTablesCount] = useState(0)
  const [boardState, setBoardState] = useState(null);
  const [balance, setBalance] = useState(0);
  const [blockStol, setBlockStol] = useState('false');






// Пример: в GameContext.js
const [tournamentBoardState, setTournamentBoardState] = useState([]);
const [tournamentPlayerColor, setTournamentPlayerColor] = useState(null);
const [tournamentOpponentColor, setTournamentOpponentColor] = useState(null);
// ... остальное (currentTurn, firstRolls, etc.)



const [tickets, setTickets] = useState([]);
const [skins, setSkins] = useState([]);


useEffect(() => {
  socket.on('tablesList', (newTables) => {
    
    
    setTables(newTables); // ← обновит контекст
  });

  return () => socket.off('tablesList');
}, []);



  // Сохранение в localStorage при изменении
  // useEffect(() => {
  //   localStorage.setItem('openTablesCount', openTablesCount);
  // }, [openTablesCount]);

  // const updateTableState = (tableId, changes) => {
 
  
  //   const updatedTableStates = {
  //     ...tableStates,
  //     [tableId]: { ...tableStates[tableId], ...changes },
  //   };
  
  //   setTableStates(updatedTableStates);
  //   localStorage.setItem('tableStates', JSON.stringify(updatedTableStates));
  // };
  

  const [isFirstMoveDone, setIsFirstMoveDone] = useState(() => {
    // Загрузка значения isFirstMoveDone из localStorage при начальной загрузке компонента
    const savedValue = localStorage.getItem('isFirstMoveDone');
    return savedValue ? JSON.parse(savedValue) : false;
  });




 const [flagFirst, setFlagFirst] = useState(() => {
    const savedValue = localStorage.getItem('flagFirst');
    return savedValue ? parseInt(savedValue, 10) : 0;
  });



const updateGame = (update) => {

  
  setGame(update);
  if (update.currentTurn !== undefined) {
    setCurrentTurn(update.currentTurn);
  }

  // Обновляем numberMove на основе новых данных игры
  if (playerColor === 'white' && update.numberMovePlayer1 !== undefined) {
    setNumberMove(update.numberMovePlayer1);
   
  } else if (playerColor === 'black' && update.numberMovePlayer2 !== undefined) {
    setNumberMove(update.numberMovePlayer2);
    
  }
};


useEffect(() => {
  if (isInitialMount.current) {
    if (game && playerColor) {
      if (playerColor === 'white' && game.numberMovePlayer1 !== undefined) {
        setNumberMove(game.numberMovePlayer1);
      
      } else if (playerColor === 'black' && game.numberMovePlayer2 !== undefined) {
        setNumberMove(game.numberMovePlayer2);
     
      }
    }
    isInitialMount.current = false;
  }
}, [game, playerColor]);


    
// Добавил по предложению ии , непонятно нужно или нет
// const updateGame = (gameData) => {
//   setGame(gameData);
//   if (playerColor === 'white') {
//     setNumberMove(gameData.numberMovePlayer1 || 0);
//     console.log('456456456',numberMove);
    
//   } else if (playerColor === 'black') {
//     setNumberMove(gameData.numberMovePlayer2 || 0);
//     console.log('4564564567777',numberMove);
//   }
 
// };




  const handleConfirmMove = () => {
   
    
    const boardStateString = JSON.stringify(game.board_state);
    
    if (!boardStateString) {
      console.error('Ошибка сериализации boardState');
      return;
    }
    setNumberMove(2); // Or set to 0 if appropriate
  
    socket.emit('confirmMove', {
      tableId: game.table_id,
      player: currentTurn,
      boardState: boardStateString,
      playerColor: playerColor,
      firstRollComplete: firstRollComplete !== undefined ? firstRollComplete : true 
    });
  
    const nextTurn = currentTurn === 'player1' ? 'player2' : 'player1';
 
    
    setRollDiceEnabled(true);
    setTurnCompleted(true);
    

    setCurrentTurn(nextTurn);

    // Обновляем состояние testik для следующего хода
    // setTestik(nextTurn === (playerColor === 'white' ? 'player2' : 'player1'));
  };

  
  const updateReadyStatus = (player, status) => {
    setReadyStatus(prev => {
      const newStatus = { ...prev, [player]: status };
      const rollEnabled = newStatus.player1 && newStatus.player2;
      
      // setRollEnabled(rollEnabled);
    
      return newStatus;
      
      
    });
  };







  
  useEffect(() => {
    const handleConfirmMove = (data) => {
    
  
      if (!data.boardState) {
        console.error('boardState is undefined or empty');
        return;
      }
  
      try {
        const parsedBoardState = JSON.parse(data.boardState);
       
  
        setGame(prevGame => {
          const newGameState = {
            ...prevGame,
            board_state: parsedBoardState,
            current_turn: data.currentTurn
          };
         
          return newGameState;
        });
  
        // Обновляем состояние testik для текущего игрока
        // setTestik(data.currentTurn === (playerColor === 'white' ? 'player2' : 'player1'));
  
      } catch (error) {
        console.error('Ошибка при подтверждении хода:', error);
      }
    };
  
    socket.on('confirmMove', handleConfirmMove);
  
    return () => {
      socket.off('confirmMove', handleConfirmMove);
    };
  }, [playerColor]);

  return (
    <GameContext.Provider value={{
      setGame, game, updateGame, diceRolls,dataLoaded, setDataLoaded, setDiceRolls, numberMove, setNumberMove,
      firstRolls, setFirstRolls, currentTurn, setCurrentTurn, rollEnabled, setRollEnabled,
      rollDiceEnabled, setRollDiceEnabled, confirmMoveEnabled, setConfirmMoveEnabled, turnCompleted, setTurnCompleted,
      readyStatus, updateReadyStatus, showRollDiceButton, setShowRollDiceButton, handleConfirmMove,roll1, setRoll1,
      roll2, setRoll2, testik, setTestik,isFirstMoveDone, setIsFirstMoveDone,
      playerColor,blockStol, setBlockStol, setPlayerColor,tournamentFirstRolls,tournamentWhiteOffBoard,tournamentBlackOffBoard, setTournamentBlackOffBoard, setTournamentWhiteOffBoard,tournamentFirstRollComplete, setTournamentFirstRollComplete, setTournamentFirstRolls,tournamentRollEnabled, setTournamentRollEnabled,tournamentBoardState,tournamentOpponentColor, setTournamentOpponentColor, setTournamentBoardState,tournamentPlayerColor, setTournamentPlayerColor, setOpenTablesCount,balance, setBalance,readyStatus, setReadyStatus,isTournament, setIsTournament,boardState, setBoardState,tables,whiteOffBoard, setWhiteOffBoard,tablesLong,setTablesLong,tablesKhachapuri,setTablesKhachapuri,flagFirst, setFlagFirst,blackOffBoard, setBlackOffBoard, setTables,usedRolls,enteredCheckerData, setCapturedCheckers, setEnteredCheckerData, setUsedRolls,moveHistory, setMoveHistory,lastEnteredChecker,bar, setBar,hasJoined, setHasJoined,isFirstRollEnabled, setIsFirstRollEnabled,canMove, setCanMove, setLastEnteredChecker,capturedCheckers,capturedCheckerData,enteredChecker, setEnteredChecker, setCapturedCheckerData,rolledDice,firstMoveComplete, setFirstMoveComplete, setRolledDice, firstRollComplete, setFirstRollComplete,currentTableId, setCurrentTableId,tournamentCapturedCheckers, setTournamentCapturedCheckers,tournamentRolledDice, setTournamentRolledDice,tournamentUsedRolls, setTournamentUsedRolls,
       tickets, setTickets,skins, setSkins,
      //  tableStates, setTableStates,
    }}>
      {children}
    </GameContext.Provider>  
  ); 
};
 




// import React, { createContext, useState, useContext, useEffect,useRef  } from 'react';
// import socket from '../socket';

// const GameContext = createContext();

// export const useGame = () => useContext(GameContext);

// export const GameProvider = ({ children }) => {
//   const [game, setGame] = useState(null);
//   const [diceRolls, setDiceRolls] = useState({ player1Roll: null, player2Roll: null });
//   const [numberMove, setNumberMove] = useState(2);


  
  
//   const [firstRolls, setFirstRolls] = useState({ player1Roll: null, player2Roll: null });
//   const [tournamentFirstRolls, setTournamentFirstRolls] = useState({ player1Roll: null, player2Roll: null });
//   const [isFirstRollEnabled, setIsFirstRollEnabled] = useState({ player1FirstRollEnabled: true, player2FirstRollEnabled: true }); 
//   const [currentTurn, setCurrentTurn] = useState(null);
//   const [rollEnabled, setRollEnabled] = useState(false);
//   const [tournamentRollEnabled, setTournamentRollEnabled] = useState(false);
//   const [rollDiceEnabled, setRollDiceEnabled] = useState(false);
//   const [confirmMoveEnabled, setConfirmMoveEnabled] = useState(false);
//   const [readyStatus, setReadyStatus] = useState({ player1: false, player2: false });
//   const [turnCompleted, setTurnCompleted] = useState(false);
//   const [showRollDiceButton, setShowRollDiceButton] = useState(true); 
//   const [testik, setTestik] = useState(false);
//   const [playerColor, setPlayerColor] = useState(null);
//   const [rolledDice, setRolledDice] = useState([]);
//   const [tournamentRolledDice, setTournamentRolledDice] = useState([]);
//   const [isTournament, setIsTournament] = useState(false);
//   // const [hasRolledDice, setHasRolledDice] = useState(false); // Индикатор, бросил ли кубики
//   // const [showReadyButton, setShowReadyButton] = useState(false);
//   // const [showReadyButton, setShowReadyButton] = useState(() => {
//   //   // Проверяем, сохранено ли состояние в localStorage
//   //   const storedState = localStorage.getItem("showReadyButton");
//   //   // Если состояние сохранено, парсим его, иначе возвращаем true
//   //   return storedState !== null ? JSON.parse(storedState) : true;
//   // });
//   // const [showReadyButton, setShowReadyButton]= useState()
//   const [usedRolls, setUsedRolls] = useState([]); // Добавляем это состояние
//   const [tournamentUsedRolls, setTournamentUsedRolls] = useState([]); // Добавляем это состояние
//   const [moveHistory, setMoveHistory] = useState([]); // Сохраняем историю ходов




//   const [firstRollComplete, setFirstRollComplete] = useState(false);
//   const [tournamentFirstRollComplete, setTournamentFirstRollComplete] = useState(false);
//   const [roll1, setRoll1] = useState(null);
//   const [roll2, setRoll2] = useState(null);
//   const [firstMoveComplete, setFirstMoveComplete] = useState(false);
//   const [capturedCheckers, setCapturedCheckers] = useState({ white: 0, black: 0 });
//   const [tournamentCapturedCheckers, setTournamentCapturedCheckers] = useState({ white: 0, black: 0 });
//   const [capturedCheckerData, setCapturedCheckerData] = useState(null);
//   // const [enteredCheckerData, setEnteredCheckerData] = useState(null);
//   const [enteredChecker, setEnteredChecker] = useState(null);
//   const [enteredCheckerData, setEnteredCheckerData] = useState({ white: 0, black: 0 });
//   const [lastEnteredChecker, setLastEnteredChecker] = useState(null); 
//   const [bar, setBar] = useState({ white: [], black: [] });
//   const [canMove, setCanMove] = useState(false); // Контролирует, можно ли сделать ход
//   const [hasJoined, setHasJoined] = useState(false); // Контролирует, можно ли сделать ход
//   const [tables, setTables] = useState([]);
//   const [tablesLong,setTablesLong] = useState([]);
//   const [dataLoaded, setDataLoaded] = useState(false);
//   const [whiteOffBoard, setWhiteOffBoard] = useState([]);
//   const [blackOffBoard, setBlackOffBoard] = useState([]);
//   const [tournamentWhiteOffBoard, setTournamentWhiteOffBoard] = useState([]);
//   const [tournamentBlackOffBoard, setTournamentBlackOffBoard] = useState([]);
//   const isInitialMount = useRef(true);
//   // const [currentTableId, setCurrentTableId] = useState(null); // Состояние для текущего стола
//   const [currentTableId, setCurrentTableId] = useState(localStorage.getItem('currentTableId') || null);
//   const [tableStates, setTableStates] = useState(() => {
//     const savedTableStates = localStorage.getItem('tableStates');
//     return savedTableStates ? JSON.parse(savedTableStates) : {};
//   });
//   // const [tableStates, setTableStates] = useState({});
//   const [openTablesCount, setOpenTablesCount] = useState(0)
//   const [boardState, setBoardState] = useState(null);
//   const [balance, setBalance] = useState(0);
//   const [blockStol, setBlockStol] = useState('false');






// // Пример: в GameContext.js
// const [tournamentBoardState, setTournamentBoardState] = useState([]);
// const [tournamentPlayerColor, setTournamentPlayerColor] = useState(null);
// const [tournamentOpponentColor, setTournamentOpponentColor] = useState(null);
// // ... остальное (currentTurn, firstRolls, etc.)



// const [tickets, setTickets] = useState([]);
// const [skins, setSkins] = useState([]);


// useEffect(() => {
//   socket.on('tablesList', (newTables) => {
    
    
//     setTables(newTables); // ← обновит контекст
//   });

//   return () => socket.off('tablesList');
// }, []);



//   // Сохранение в localStorage при изменении
//   // useEffect(() => {
//   //   localStorage.setItem('openTablesCount', openTablesCount);
//   // }, [openTablesCount]);

//   // const updateTableState = (tableId, changes) => {
 
  
//   //   const updatedTableStates = {
//   //     ...tableStates,
//   //     [tableId]: { ...tableStates[tableId], ...changes },
//   //   };
  
//   //   setTableStates(updatedTableStates);
//   //   localStorage.setItem('tableStates', JSON.stringify(updatedTableStates));
//   // };
  

//   const [isFirstMoveDone, setIsFirstMoveDone] = useState(() => {
//     // Загрузка значения isFirstMoveDone из localStorage при начальной загрузке компонента
//     const savedValue = localStorage.getItem('isFirstMoveDone');
//     return savedValue ? JSON.parse(savedValue) : false;
//   });




//  const [flagFirst, setFlagFirst] = useState(() => {
//     const savedValue = localStorage.getItem('flagFirst');
//     return savedValue ? parseInt(savedValue, 10) : 0;
//   });



// const updateGame = (update) => {

  
//   setGame(update);
//   if (update.currentTurn !== undefined) {
//     setCurrentTurn(update.currentTurn);
//   }

//   // Обновляем numberMove на основе новых данных игры
//   if (playerColor === 'white' && update.numberMovePlayer1 !== undefined) {
//     setNumberMove(update.numberMovePlayer1);
   
//   } else if (playerColor === 'black' && update.numberMovePlayer2 !== undefined) {
//     setNumberMove(update.numberMovePlayer2);
    
//   }
// };


// useEffect(() => {
//   if (isInitialMount.current) {
//     if (game && playerColor) {
//       if (playerColor === 'white' && game.numberMovePlayer1 !== undefined) {
//         setNumberMove(game.numberMovePlayer1);
      
//       } else if (playerColor === 'black' && game.numberMovePlayer2 !== undefined) {
//         setNumberMove(game.numberMovePlayer2);
     
//       }
//     }
//     isInitialMount.current = false;
//   }
// }, [game, playerColor]);


    
// // Добавил по предложению ии , непонятно нужно или нет
// // const updateGame = (gameData) => {
// //   setGame(gameData);
// //   if (playerColor === 'white') {
// //     setNumberMove(gameData.numberMovePlayer1 || 0);
// //     console.log('456456456',numberMove);
    
// //   } else if (playerColor === 'black') {
// //     setNumberMove(gameData.numberMovePlayer2 || 0);
// //     console.log('4564564567777',numberMove);
// //   }
 
// // };




//   const handleConfirmMove = () => {
   
    
//     const boardStateString = JSON.stringify(game.board_state);
    
//     if (!boardStateString) {
//       console.error('Ошибка сериализации boardState');
//       return;
//     }
//     setNumberMove(2); // Or set to 0 if appropriate
  
//     socket.emit('confirmMove', {
//       tableId: game.table_id,
//       player: currentTurn,
//       boardState: boardStateString,
//       playerColor: playerColor,
//       firstRollComplete: firstRollComplete !== undefined ? firstRollComplete : true 
//     });
  
//     const nextTurn = currentTurn === 'player1' ? 'player2' : 'player1';
 
    
//     setRollDiceEnabled(true);
//     setTurnCompleted(true);
    

//     setCurrentTurn(nextTurn);

//     // Обновляем состояние testik для следующего хода
//     // setTestik(nextTurn === (playerColor === 'white' ? 'player2' : 'player1'));
//   };

  
//   const updateReadyStatus = (player, status) => {
//     setReadyStatus(prev => {
//       const newStatus = { ...prev, [player]: status };
//       const rollEnabled = newStatus.player1 && newStatus.player2;
      
//       // setRollEnabled(rollEnabled);
    
//       return newStatus;
      
      
//     });
//   };







  
//   useEffect(() => {
//     const handleConfirmMove = (data) => {
    
  
//       if (!data.boardState) {
//         console.error('boardState is undefined or empty');
//         return;
//       }
  
//       try {
//         const parsedBoardState = JSON.parse(data.boardState);
       
  
//         setGame(prevGame => {
//           const newGameState = {
//             ...prevGame,
//             board_state: parsedBoardState,
//             current_turn: data.currentTurn
//           };
         
//           return newGameState;
//         });
  
//         // Обновляем состояние testik для текущего игрока
//         // setTestik(data.currentTurn === (playerColor === 'white' ? 'player2' : 'player1'));
  
//       } catch (error) {
//         console.error('Ошибка при подтверждении хода:', error);
//       }
//     };
  
//     socket.on('confirmMove', handleConfirmMove);
  
//     return () => {
//       socket.off('confirmMove', handleConfirmMove);
//     };
//   }, [playerColor]);

//   return (
//     <GameContext.Provider value={{
//       setGame, game, updateGame, diceRolls,dataLoaded, setDataLoaded, setDiceRolls, numberMove, setNumberMove,
//       firstRolls, setFirstRolls, currentTurn, setCurrentTurn, rollEnabled, setRollEnabled,
//       rollDiceEnabled, setRollDiceEnabled, confirmMoveEnabled, setConfirmMoveEnabled, turnCompleted, setTurnCompleted,
//       readyStatus, updateReadyStatus, showRollDiceButton, setShowRollDiceButton, handleConfirmMove,roll1, setRoll1,
//       roll2, setRoll2, testik, setTestik,isFirstMoveDone, setIsFirstMoveDone,
//       playerColor,blockStol, setBlockStol, setPlayerColor,tournamentFirstRolls,tournamentWhiteOffBoard,tournamentBlackOffBoard, setTournamentBlackOffBoard, setTournamentWhiteOffBoard,tournamentFirstRollComplete, setTournamentFirstRollComplete, setTournamentFirstRolls,tournamentRollEnabled, setTournamentRollEnabled,tournamentBoardState,tournamentOpponentColor, setTournamentOpponentColor, setTournamentBoardState,tournamentPlayerColor, setTournamentPlayerColor, setOpenTablesCount,balance, setBalance,readyStatus, setReadyStatus,isTournament, setIsTournament,boardState, setBoardState,tables,whiteOffBoard, setWhiteOffBoard,tablesLong,setTablesLong,flagFirst, setFlagFirst,blackOffBoard, setBlackOffBoard, setTables,usedRolls,enteredCheckerData, setCapturedCheckers, setEnteredCheckerData, setUsedRolls,moveHistory, setMoveHistory,lastEnteredChecker,bar, setBar,hasJoined, setHasJoined,isFirstRollEnabled, setIsFirstRollEnabled,canMove, setCanMove, setLastEnteredChecker,capturedCheckers,capturedCheckerData,enteredChecker, setEnteredChecker, setCapturedCheckerData,rolledDice,firstMoveComplete, setFirstMoveComplete, setRolledDice, firstRollComplete, setFirstRollComplete,currentTableId, setCurrentTableId,tournamentCapturedCheckers, setTournamentCapturedCheckers,tournamentRolledDice, setTournamentRolledDice,tournamentUsedRolls, setTournamentUsedRolls,
//        tickets, setTickets,skins, setSkins,
//       //  tableStates, setTableStates,
//     }}>
//       {children}
//     </GameContext.Provider>  
//   ); 
// };
 



